/** Class to manage class html */
export default class HTMLClass {
    /**
     * Add class to DOM element
     * @param {Object} $el 
     * @param {String} className 
     */
    static addClass($el, className) {
        if ($el.classList)
            $el.classList.add(className);
        else
            $el.className += ' ' + className;
        return $el;
    }

    /**
     * Remove class from DOM element
     * @param {object} $el 
     * @param {string} className 
     */
    static removeClass($el, className) {
        if ($el.classList)
            $el.classList.remove(className);
        else
            $el.className = $el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        return $el;
    }

    /**
     * Toogle exist class in DOM element
     * @param {object} $el 
     * @param {string} className 
     */
    static toggleClass($el, className) {
        if ($el.classList) {
            $el.classList.toggle(className);
        } else {
            var classes = $el.className.split(' ');
            var existingIndex = classes.indexOf(className);

            if (existingIndex >= 0)
                classes.splice(existingIndex, 1);
            else
                classes.push(className);

            $el.className = classes.join(' ');
        }
        return $el;
    }

    /**
     * Check if DOM element has class name
     * @param {object} $el 
     * @param {string} className 
     */
    static hasClass($el, className) {
        if ($el.classList)
            return $el.classList.contains(className);
        else
            return new RegExp('(^| )' + className + '( |$)', 'gi').test($el.className);
    }
}